import React from "react"
import PropTypes from "prop-types"
import cn from "classnames"
import injectSheet from "react-jss"
import { Icon, Text } from "@xingternal/360-components"
import { t } from "@/i18n"
import products, { getProduct } from "@/helpers/products"

const styles = {
  container: {
    composes: "gray-80 flex flex-column justify-between pb24",
    height: 320,
  },
  title: { composes: "mb16" },
  titleText: { composes: "inline-block vam" },
  content: { composes: "flex justify-between" },
  intro: { composes: "mb16 pr24" },
  bulletsContainer: { composes: "mb16" },
  bullet: { composes: "mb4" },
  bulletIcon: { composes: "mr4 float-left" },
  bulletContent: { composes: "ovh" },
  image: { composes: "ml24", width: 175 },
  cta: { composes: "bold tp15 cursor-pointer" },
  seatAvailableMessage: {
    composes: "p12 rounded bg-gray-5",
  },
}

const Title = injectSheet(styles)(({ children, classes }) => (
  <div className={classes.title}>
    <Text size={18} bold className={classes.titleText}>
      {children}
    </Text>
  </div>
))

const ListItem = injectSheet(styles)(({ children, classes }) => (
  <Text className={classes.bullet}>
    <Icon size={14} name="shape-tick" className={classes.bulletIcon} />
    <div className={classes.bulletContent}>{children}</div>
  </Text>
))

/* eslint-disable */
const ProductBrochure = ({
  classes = {},
  className,
  image,
  intro,
  moreInfoLabel,
  listItems,
  onMoreInfo,
  title,
  product,
  showAvailableProductNotice,
}) => (
  <div className={cn(classes.container, className)}>
    <div>
      <Title>{title}</Title>
      <div className={classes.content}>
        <div>
          <Text className={classes.intro}>{intro}</Text>
          <div className={classes.bulletsContainer}>
            {listItems.map((key, i) => (
              <ListItem key={`li-${i}`}>{key}</ListItem>
            ))}
          </div>
        </div>
        <div className={classes.image}>{image}</div>
      </div>
    </div>
    {showAvailableProductNotice ? (
      <div className={classes.seatAvailableMessage}>
        {t("360_RECRUITER_INSIGHTS_ACCESS", {
          name: getProduct(product).title,
        })}
      </div>
    ) : (
      <a onClick={onMoreInfo} className={classes.cta}>
        {moreInfoLabel}
      </a>
    )}
  </div>
)
/* eslint-enable */

ProductBrochure.propTypes = {
  className: PropTypes.string,
  image: PropTypes.element.isRequired,
  intro: PropTypes.string.isRequired,
  moreInfoLabel: PropTypes.string,
  listItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  onMoreInfo: PropTypes.func,
  title: PropTypes.string.isRequired,
  product: PropTypes.oneOf(Object.keys(products)).isRequired,
  showAvailableProductNotice: PropTypes.bool,
}

export const StyledProductBrochure = injectSheet(styles)(ProductBrochure)
export default ProductBrochure
